import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class JobInstanceService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(
      http,
      `${environment.apiBaseUrl}/companies/%(company_id)s/job_instances`
    );
  }

  copyFromCompany(
    payload: { source_company_id: string; job_instance_ids: number[] },
    urlParams: any = {}
  ): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/job_instances/copy_from`, urlParams);
    return this.http.post<any>(url, payload);
  }

  trigger(id: string, urlParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/job_instances/${id}/trigger`, urlParams);
    return this.http.post<any>(url, {});
  }

  snapshot(urlParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/job_instances/snapshot`, urlParams);
    return this.http.post<any>(url, {});
  }
}
